'use strict';

exports.__esModule = true;
exports.EnhancedTableToolbar = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('material-ui/styles');

var _Toolbar = require('material-ui/Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Tooltip = require('material-ui/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _AddCircleOutline = require('material-ui-icons/AddCircleOutline');

var _AddCircleOutline2 = _interopRequireDefault(_AddCircleOutline);

var _colorManipulator = require('material-ui/styles/colorManipulator');

var _Grid = require('material-ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _ChoseColumns = require('./ChoseColumns');

var _ChoseColumns2 = _interopRequireDefault(_ChoseColumns);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import DeleteIcon from 'material-ui-icons/Delete';
// import FilterListIcon from 'material-ui-icons/FilterList';
// import ExportToExcel from "./ExportToExcel";


var toolbarStyles = function toolbarStyles(theme) {
  return {
    root: {
      paddingRight: theme.spacing.unit,
      alignItems: "flex-end"
    },
    highlight: theme.palette.type === 'light' ? {
      color: theme.palette.secondary.dark,
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    } : {
      color: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4),
      backgroundColor: theme.palette.secondary.dark
    },
    spacer: {
      flex: '1 1 100%'
    },
    actions: {
      color: theme.palette.text.secondary,
      display: "flex"
    },
    title: {
      flex: '0 0 auto'
    }
  };
};

var EnhancedTableToolbar = exports.EnhancedTableToolbar = function (_Component) {
  _inherits(EnhancedTableToolbar, _Component);

  function EnhancedTableToolbar() {
    _classCallCheck(this, EnhancedTableToolbar);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  EnhancedTableToolbar.prototype.render = function render() {
    var _props = this.props,
        numSelected = _props.numSelected,
        classes = _props.classes,
        title = _props.title,
        addObject = _props.addObject,
        filters = _props.filters,
        columnData = _props.columnData,
        toggleColumnVisibility = _props.toggleColumnVisibility,
        exportable = _props.exportable,
        table = _props.table;
    var columns = [];

    if (title) {
      columns.push(_react2.default.createElement(_Grid2.default, {
        key: 'title',
        item: true
      }, _react2.default.createElement(_Typography2.default, {
        type: 'title'
      }, title)));
    }

    if (filters) {
      columns.push(_react2.default.createElement(_Grid2.default, {
        key: 'filters',
        item: true,
        xs: true
      }, filters));
    } else {
      columns.push(_react2.default.createElement(_Grid2.default, {
        key: 'separator',
        item: true,
        xs: true
      }, null));
    } // if (exportable) {
    //   columns.push(<Grid
    //     key="ExportToExcel"
    //     item
    //   >
    //     <ExportToExcel
    //       columnData={columnData}
    //       table={table}
    //     />
    //   </Grid>);
    // }


    if (columnData && columnData.length) {
      columns.push(_react2.default.createElement(_Grid2.default, {
        key: 'ChoseColumns',
        item: true
      }, _react2.default.createElement(_ChoseColumns2.default, {
        columnData: columnData,
        toggleColumnVisibility: toggleColumnVisibility
      })));
    }

    if (addObject) {
      var _global = global,
          document = _global.document;

      var _ref = document || {},
          createRange = _ref.createRange;

      if (createRange) {
        /**
         * https://github.com/jsdom/jsdom/issues/317
         */
        columns.push(_react2.default.createElement(_Grid2.default, {
          key: 'add',
          item: true
        }, _react2.default.createElement(_Tooltip2.default, {
          title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"
        }, _react2.default.createElement(_IconButton2.default, {
          'aria-label': 'AddPlace',
          onClick: addObject
        }, _react2.default.createElement(_AddCircleOutline2.default, null)))));
      }
    }

    return _react2.default.createElement(_Toolbar2.default, {
      className: [classes.root, numSelected > 0 ? classes.highlight : null].join(" ")
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      alignItems: 'center'
    }, columns));
  };

  return EnhancedTableToolbar;
}(_react.Component);

EnhancedTableToolbar.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes2.default.object.isRequired,
  numSelected: _propTypes2.default.number.isRequired,
  title: _propTypes2.default.string.isRequired,
  addObject: _propTypes2.default.func,
  columnData: _propTypes2.default.array.isRequired,
  toggleColumnVisibility: _propTypes2.default.func.isRequired,
  exportable: _propTypes2.default.bool.isRequired,
  table: _propTypes2.default.instanceOf(HTMLTableElement).isRequired
} : {};
exports.default = (0, _styles.withStyles)(toolbarStyles)(function (props) {
  return _react2.default.createElement(EnhancedTableToolbar, props);
});